export class MapBasemap {
    basemapName: string;
    portalItemId: string;

    constructor(object?: any) {
        this.basemapName = object?.basemapName;
        this.portalItemId = object?.portalItemId;
    }
}

export class MapProfile {
    id: string;
    name: string;
    default: boolean;
    cloudConnection: { name: string; mapUrl: string };
    defaultBasemap: MapBasemap;
    gallery: MapBasemap[];

    constructor(object?: any) {
        this.id = object?.id;
        this.name = object?.name;
        this.default = object?.default ?? false;
        this.cloudConnection = object?.cloudConnection ?? { name: 'agol', mapUrl: '' };
        this.defaultBasemap = new MapBasemap(object?.defaultBasemap);
        this.gallery = (object?.gallery ?? []).map(basemap => new MapBasemap(basemap));
    }
}

export class CredentialStore {
    description: string;
    clientId: string;
    clientSecret: string;

    constructor(object?: any) {
        this.description = object?.description;
        this.clientId = object?.clientId;
        this.clientSecret = object?.clientSecret;
    }
}

export class PsapMapProfile {
    id: string;
    psapId: string;
    mapProfile: MapProfile | { id: string };
    credentialStore: CredentialStore;
    default: boolean;

    constructor(object?: any) {
        this.id = object?.id;
        this.psapId = object?.psapId;
        this.mapProfile = object?.mapProfile?.name ? new MapProfile(object.mapProfile) : object?.mapProfile;
        this.credentialStore = new CredentialStore(object?.credentialStore);
        this.default = object?.default ?? false;
    }
}
